import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-premium";
import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

export type AdminPageMode = "none" | "new" | "edit" | "view";

interface AdminPageProps {
  mode: AdminPageMode;
  selectedKey: string | null;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
}

interface AdminPageState {
  pages: Record<string, AdminPageProps>;
}

const initialState: AdminPageState = {
  pages: {},
};

const adminPageSlice = createSlice({
  name: "adminPage",
  initialState,
  reducers: {
    addPage: (state, action: PayloadAction<[string, GridSortModel | undefined, GridFilterModel | undefined]>) => {
      if (!(action.payload[0] in state.pages)) {
        const page: AdminPageProps = {
          mode: "none",
          selectedKey: null,
          sortModel: action.payload[1] ?? [],
          filterModel: action.payload[2] ?? { items: [] },
        };
        state.pages[action.payload[0]] = page;
      }
    },
    setMode: (state, action: PayloadAction<[string, AdminPageMode]>) => {
      state.pages[action.payload[0]].mode = action.payload[1];
    },
    setSelectedKey: (state, action: PayloadAction<[string, string | null]>) => {
      state.pages[action.payload[0]].selectedKey = action.payload[1];
      state.pages[action.payload[0]].mode = "view";
    },
    setSortModel: (state, action: PayloadAction<[string, GridSortModel]>) => {
      state.pages[action.payload[0]].sortModel = action.payload[1];
    },
    setFilterModel: (state, action: PayloadAction<[string, GridFilterModel]>) => {
      state.pages[action.payload[0]].filterModel = action.payload[1];
    },
  },
});

export const selectAdminPage = createSelector(
  [(state) => state.adminPage.pages, (state, pageName) => pageName],
  (pages, pageName) => pages[pageName] ?? {}
);

export const { addPage, setMode, setSelectedKey, setSortModel, setFilterModel } = adminPageSlice.actions;

export default adminPageSlice.reducer;
